module.exports = __webpack_public_path__ + "img/main_container.9256a00f.png";